<div class="toast-container">
  <div 
    class="toast" 
    *ngFor="let t of (toasts$ | async)"
    [class.success]="t.type === 'success'"
    [class.error]="t.type === 'error'"
    [class.info]="t.type === 'info'"
    [class.warning]="t.type === 'warning'"
  >
    <div class="toast-content">
      <span class="icon" aria-hidden="true">
        <ng-container [ngSwitch]="t.type">
          <span *ngSwitchCase="'success'">✔</span>
          <span *ngSwitchCase="'error'">✖</span>
          <span *ngSwitchCase="'warning'">⚠</span>
          <span *ngSwitchDefault>ℹ</span>
        </ng-container>
      </span>
      <span class="message">{{ t.message }}</span>
      <button class="close" (click)="dismiss(t.id)" aria-label="Close">×</button>
    </div>
  </div>
</div>
